import { WorkspaceOptionsMenu } from '../components/WorkspaceOptionsMenu';

export default WorkspaceOptionsMenu;
